import React, { useEffect, useState } from 'react';
import "./SpecialistFormHours.scss"
import Dropdown from '../../../UI/Dropdown/Dropdown'
import { useSelector } from 'react-redux';
import { secondsToTime, getWorkTime } from '../../../../helpers/datetime';

import { createTimeSlotsForSpecialist, createTimeSlotsWithHoursSum } from '../../../../helpers/table';

const scheduleTimeType = [
    { id: 1, value: 'По графику салона', is_personal_hours: 0 },
    { id: 2, value: 'Индивидуально', is_personal_hours: 1 }
]

const SpecialistFormHours = ({ selectedHoursType = null, selectedHoursStart = null, selectedHoursEnd = null, selectedType = 0, hoursStart = null, hoursEnd = null, errorMessage = '' }) => {
    const [timeType, setTimeType] = useState()
    const [timeSlots, setTimeSlots] = useState([])
    const [slotsEnd, setSlotsEnd] = useState(createTimeSlotsWithHoursSum())

    const [timeStart, setTimeStart] = useState(null)
    const [timeEnd, setTimeEnd] = useState(null)

    useEffect(() => {
        setTimeSlots(createTimeSlotsForSpecialist())
        
        const itemType = scheduleTimeType.filter(item => item.is_personal_hours == selectedType)
        
        setTimeType(itemType[0])

        if (hoursStart) {
            setTimeStart(secondsToTime(hoursStart))
        } else {
            setTimeStart(timeSlots[0])
        }

        if (hoursEnd) {
            setTimeEnd(getWorkTime(hoursStart ? hoursStart : 36000, hoursEnd))
        } else {
            setTimeEnd(slotsEnd[slotsEnd.length - 1])
        }
    }, [])

    useEffect(() => {
        if (hoursStart) {
            setSlotsEnd(createTimeSlotsWithHoursSum(hoursStart))
        }        
    }, [hoursStart])    
    
    const timeTypeSelect = (type) => {
        
        const itemType = scheduleTimeType.filter(item => item.id === type)
        setTimeType(itemType[0])
        selectedHoursType(itemType[0].is_personal_hours)
    }

    const handleSelectedHoursStart = (type) => {
        setTimeStart(type)
        selectedHoursStart(type)
    }

    const handleSelectedHoursEnd = (type) => {
        selectedHoursEnd(type)
    }

    return (
        <div className="specialist-form-hours">
            <div className="specialist-form__time-type">
                <Dropdown
                    optionsList={scheduleTimeType}
                    optionSelected={timeType}
                    type='timeType'
                    label='Желаемое время работы'
                    selectedHandler={timeTypeSelect} />
            </div>
            {timeType && timeType.is_personal_hours == true &&
                <div className="specialist-form__time-block">
                    <div className="specialist-form__time-selector">
                        <Dropdown
                            optionsList={timeSlots}
                            optionSelected={timeStart ? timeStart : timeSlots[0]}
                            type='startHours'
                            label=''
                            selectedHandler={handleSelectedHoursStart} />
                    </div>
                    <div className="specialist-form-hours__line"></div>
                    <div className="specialist-form__time-selector">
                        <Dropdown
                            optionsList={slotsEnd}
                            optionSelected={timeEnd}
                            type='endHours'
                            label=''
                            selectedHandler={handleSelectedHoursEnd} />
                    </div>
                </div>
            }

            {errorMessage !== '' &&
                <div className="specialist-form-hours__error">
                    {errorMessage}
                </div>
            }
        </div>
    );
}

export default SpecialistFormHours;